const locales = {
  DE: 'de_DE',
  EN: 'en_GB',
  ES: 'es_ES',
  FR: 'fr_FR',
  IT: 'it_IT',
  NL: 'nl_NL',
  PL: 'pl_PL',
  PT: 'pt_PT',
  ZH: 'zh_CN'
};

export const localeToHyphenFormat = locale => locale.replace('_', '-');

export default locales;
